import service from '@/store/services/vendors/labourer-payments-service';

const state = {
    list: {},
    labourerPaymentItems: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerPaymentItems) => {
        state.labourerPaymentItems = labourerPaymentItems;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({ commit }, params) {
        params = params || {};
        commit('SET_LOADING', true);
        return service.list(params)
            .then(function (response) {
                commit('SET_LIST', response.list);
                commit('SET_META', response.meta);
                return response;
            })
            .finally(function () {
                commit('SET_LOADING', false);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourerPaymentItems => {
                commit('SET_RESOURCE', labourerPaymentItems);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourerPaymentItems => {
                commit('SET_RESOURCE', labourerPaymentItems);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourerPaymentItems) => {
                commit('SET_RESOURCE', labourerPaymentItems);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourerPaymentItems) => {
                commit('SET_RESOURCE', labourerPaymentItems);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: function (state) {
        if (!state.meta) return 0;
        if (state.meta.total) return state.meta.total;
        if (state.meta.page && state.meta.page.total) return state.meta.page.total;
        return 0;
    },
    meta: function (state) { return state.meta; },
    labourerPaymentItems: state => state.labourerPaymentItems,
    dropdown: (state) => {
        return state.list.map(labourerPaymentItems => ({
            uuid: labourerPaymentItems.uuid,
            labourer_schedule_id: labourerPaymentItems.labourer_schedule_id
        }));
    }
};

const labourerPaymentItems = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerPaymentItems;
